import { Button } from '../../../../../design-system/button/button';
import { Stack } from '../../../../../design-system/stack/stack';
import { PayeeCheckResultCard } from '../../financial-information-step/payee-check-result-card';

type BankAccountDetailsConformationProps = {
  onEditDetails: () => void;
  onContinue: () => void;
};

export const BankAccountDetailsConfirmation = ({ onEditDetails, onContinue }: BankAccountDetailsConformationProps) => {
  return (
    <Stack align="stretch" justify="between" className="h-full">
      <PayeeCheckResultCard variantConfig={{ variant: 'CONFIRMATION' }} />

      <Stack space={2} align="stretch" className="w-full">
        <Button variant="default" size="lg" onClick={onEditDetails} className="w-full">
          Edit Details
        </Button>

        <Button variant="destructive" size="lg" onClick={onContinue} className="w-full">
          Continue Anyway
        </Button>
      </Stack>
    </Stack>
  );
};
